import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field, StatusBadge } from "@/components/common/bits";

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { applySession } = useAuth();
  const [inv, setInv] = useState(null);
  const [form, setForm] = useState({ name: "", password: "" });

  useEffect(() => { api.get(`/invites/${token}`).then((r) => setInv(r.data)).catch((e) => toast.error(errMsg(e))); }, [token]);

  const accept = async () => {
    try { const r = await api.post(`/invites/${token}/accept`, form); applySession(r.data); toast.success("Invite accepted"); navigate("/app"); }
    catch (e) { toast.error(errMsg(e)); }
  };

  if (!inv) return <div className="p-10 text-muted-foreground">Loading invite…</div>;
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="surface p-8 w-full max-w-md fade-up" data-testid="invite-card">
        <div className="eyebrow mb-2">Invitation</div>
        <h1 className="font-display text-2xl font-bold">Join {inv.org_name}</h1>
        <p className="text-muted-foreground mt-1">as <StatusBadge status={inv.role} className="ml-1" /> · {inv.email}</p>
        {inv.status !== "pending" ? <p className="mt-6 text-sm">This invite has already been used. <button className="text-primary underline" onClick={() => navigate("/login")}>Log in</button></p> : (
          <div className="space-y-4 mt-6">
            <Field label="Your name"><Input data-testid="invite-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Field>
            <Field label="Choose a password" hint="If you already have an account, this password is ignored."><Input data-testid="invite-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></Field>
            <Button className="w-full" onClick={accept} data-testid="invite-accept-btn">Accept invitation</Button>
          </div>
        )}
      </div>
    </div>
  );
}
